export const SetLogin = 'SetLogin';
export const GetLogin = 'GetLogin';